import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
import { convertThreshold } from 'z3k-parser/model/z3k-config/sensors/utils';
export var AnalogTemperatureSensor;
(function (AnalogTemperatureSensor) {
    let Type;
    (function (Type) {
        Type[Type["DEFAULT"] = -1] = "DEFAULT";
        Type[Type["Pt100"] = 0] = "Pt100";
        Type[Type["Pt500"] = 1] = "Pt500";
        Type[Type["Pt1000"] = 2] = "Pt1000";
        Type[Type["NTC1"] = 3] = "NTC1";
        Type[Type["NTC1_8"] = 4] = "NTC1_8";
        Type[Type["NTC2"] = 5] = "NTC2";
        Type[Type["NTC3"] = 6] = "NTC3";
        Type[Type["NTC5"] = 7] = "NTC5";
        Type[Type["NTC10"] = 8] = "NTC10";
        Type[Type["NTC20"] = 9] = "NTC20";
        Type[Type["NTC47"] = 10] = "NTC47";
        Type[Type["OTHER"] = 255] = "OTHER";
    })(Type = AnalogTemperatureSensor.Type || (AnalogTemperatureSensor.Type = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["IS_OUTSIDE"] = 1] = "IS_OUTSIDE";
        Flags[Flags["MANUAL_COLOR"] = 2] = "MANUAL_COLOR";
        Flags[Flags["COLOR_BIT_1"] = 4] = "COLOR_BIT_1";
        Flags[Flags["COLOR_BIT_2"] = 8] = "COLOR_BIT_2";
        Flags[Flags["COLOR_BIT_3"] = 16] = "COLOR_BIT_3";
        Flags[Flags["COLOR_BIT_4"] = 32] = "COLOR_BIT_4";
        Flags[Flags["COLOR_BIT_5"] = 64] = "COLOR_BIT_5";
        Flags[Flags["EVENT_TO_SERVER_FLAG_INVERTED"] = 128] = "EVENT_TO_SERVER_FLAG_INVERTED";
        Flags[Flags["IS_OUTSIDE_RESERVE"] = 256] = "IS_OUTSIDE_RESERVE";
    })(Flags = AnalogTemperatureSensor.Flags || (AnalogTemperatureSensor.Flags = {}));
    let StatusFlags;
    (function (StatusFlags) {
        StatusFlags[StatusFlags["NO_CONNECT"] = 1] = "NO_CONNECT";
        StatusFlags[StatusFlags["IS_TRIGGERED_LOW"] = 2] = "IS_TRIGGERED_LOW";
        StatusFlags[StatusFlags["IS_TRIGGERED_HIGH"] = 4] = "IS_TRIGGERED_HIGH";
        StatusFlags[StatusFlags["RESERVE"] = 8] = "RESERVE";
        StatusFlags[StatusFlags["NO_CONNECT_EVENT"] = 16] = "NO_CONNECT_EVENT";
        StatusFlags[StatusFlags["IS_RESTORED"] = 32] = "IS_RESTORED";
        /* Extention board flags */
        // TEMP_SENT = 1 << 5,
        StatusFlags[StatusFlags["EXTENTION_BOARD_SENSOR"] = 64] = "EXTENTION_BOARD_SENSOR";
        /*************************/
        StatusFlags[StatusFlags["IS_INIT"] = 128] = "IS_INIT";
    })(StatusFlags = AnalogTemperatureSensor.StatusFlags || (AnalogTemperatureSensor.StatusFlags = {}));
    function isOutside(sensor) {
        return isFlagSet(sensor, Flags.IS_OUTSIDE);
    }
    AnalogTemperatureSensor.isOutside = isOutside;
    function isOutsideReserve(sensor) {
        return isFlagSet(sensor, Flags.IS_OUTSIDE_RESERVE);
    }
    AnalogTemperatureSensor.isOutsideReserve = isOutsideReserve;
    function isEventToServer(sensor) {
        return !isFlagSet(sensor, Flags.EVENT_TO_SERVER_FLAG_INVERTED);
    }
    AnalogTemperatureSensor.isEventToServer = isEventToServer;
    function setEventToServer(sensor, eventToServer) {
        return setFlag(sensor, Flags.EVENT_TO_SERVER_FLAG_INVERTED, !eventToServer);
    }
    AnalogTemperatureSensor.setEventToServer = setEventToServer;
    function isManualColor(ats) {
        return isFlagSet(ats, Flags.MANUAL_COLOR);
    }
    AnalogTemperatureSensor.isManualColor = isManualColor;
    function getColor(sensor) {
        if (!isManualColor(sensor)) {
            return 0;
        }
        return (sensor.setting_register >> 1) & 0x1f;
    }
    AnalogTemperatureSensor.getColor = getColor;
    function setColor(sensor, color) {
        return {
            ...sensor,
            setting_register: (sensor.setting_register & ~(0x1f << 1)) | (color << 1),
        };
    }
    AnalogTemperatureSensor.setColor = setColor;
    function getLimits(sensor) {
        return {
            high: convertThreshold(sensor.upper_threshold),
            low: convertThreshold(sensor.lower_threshold),
        };
    }
    AnalogTemperatureSensor.getLimits = getLimits;
    function convertThresholds(sensor) {
        return {
            ...sensor,
            upper_threshold: convertThreshold(sensor.upper_threshold),
            lower_threshold: convertThreshold(sensor.lower_threshold),
        };
    }
    AnalogTemperatureSensor.convertThresholds = convertThresholds;
    AnalogTemperatureSensor.get = createAccessors(arrayGetSet('analog_temperature_sensors'), {
        name: 'Аналоговый датчик температуры',
        physical_input_num: -1,
        type: -1,
        upper_threshold: null,
        lower_threshold: null,
        hysteresis: 0,
        no_connection_timeout: 5,
        rol_connection_lost: [],
        rol_temperature_upper_threshold: [],
        rol_temperature_lower_threshold: [],
        recovery_list: [],
        setting_register: 0,
        ntc: null,
        pull_up: 0,
        calibration_shift: 0,
    });
})(AnalogTemperatureSensor || (AnalogTemperatureSensor = {}));
